import { injectIntl } from "react-intl";
import { getRemotedbUrl, i18nIntl, isNotEmpty } from "../../lib/ep";
import React,{ useReducer } from "react";
import FloatingLayer from "../builder/FloatingLayer";
import NavigationTabs from "../builder/NavigationTabs";
import SectionTitle from "../builder/SectionTitle";
import { Step0 } from "../backend/MediaBuilder";
import ActionButton, { BackButton } from "../builder/ActionButton";
import MediaParticipation from "../front/MediaParticipation";
import ButtonCollection from "../builder/ButtonCollection";
import { DeleteButton } from "../builder/ConfirmButton";
import Tooltip from "../builder/Tooltip";
import { v4 as uuidv4 } from 'uuid';

const CandidateManager = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const [ state, dispatch ] = useReducer(( state, action) => {
		switch(action.type) {
			
			case 'CHANGE':
				return {
					...state,
					[action.k]:action.v,
				};

			case 'CHANGE_USER':
				return {
					...state,
					candidate:{
						...state.candidate,
						User:{
							...state.candidate.User,
							[action.k]:action.v,
						},
					},
				};

			default:
				return state;
		}
	}, {
		step:0,
		candidate:props.user,
		translate:false,
		User:{},
		candidates:props?.candidates ?? [],
	});

	const submitMedias = (participation, cb) => {
		for (var media in participation.quiz_entry.media) {
			if (participation.quiz_entry.media[media].id != undefined) continue;
			participation.quiz_entry.media[media].id = uuidv4();
		}

		const id = state.candidate.User?.id ?? false;
		$.post(getRemotedbUrl(`/stages/save_candidate/${props.promotion.id}/${props.stage.id}`), {
			user:{
				User:{
					...state.candidate.User,
					...participation,
				},
			},
		}, (result) => {
			const public_fields = (props.stage?.media_form ?? []).filter(f=>f.public == 'true');

			result.user.User.public_extra_fields = {
				fields:public_fields,
				values:result.user.User.quiz_entry.form,
			};

			if(cb != undefined) cb(result);
			if(props.onSave != undefined) props.onSave(result.user);
		}, 'JSON');
	};

	const deleteCandidate = (candidate_id) => {

		$.post(getRemotedbUrl(`/users/media/delete/${props.stage.promotion_id}/${props.stage.id}`), {
			candidate_id,
		}, (res) => {
			if (props.onDelete != undefined) props.onDelete(candidate_id)
		}, 'JSON' );
	};

	const layer_sections = [{
		label:i18n("User information"),
		onClick:() => dispatch({ type:'CHANGE', k:'step', v:0 }),
		selected:(state.step == 0) ? true : false,
	}, {
		label:i18n("Participation medias"),
		onClick:() => dispatch({ type:'CHANGE', k:'step', v:1 }),
		selected:(state.step == 1) ? true : false,
	}, {
		label:i18n("Preview and confirm"),
		onClick:() => dispatch({ type:'CHANGE', k:'step', v:2 }),
		selected:(state.step == 2) ? true : false,
	}];

	const disabled_step0 = !isNotEmpty(state.candidate.User,'name');
	const is_creating = state.candidate.User.id == undefined;

	return (
		<FloatingLayer backButton={props.close}>
			<div style={{ height:'70dvh' }}>
				{!is_creating && (
					<NavigationTabs
						active={state.step}
						sections={layer_sections}
						display_type='tab'
						_class={{ other:'gui_not_in_bottom sticky_in_layer' }}
					/>
				)}

				{is_creating && (
					<SectionTitle>Create new candidate</SectionTitle>
				)}

				{(state.step == 0) ? (
					<Step0
						stage={{Stage:props.stage}}
						User={state.candidate.User}
						promotion={props.promotion}
						is_builder={true}
						changeUser={(k, v) => dispatch({ type:'CHANGE_USER', k, v })}
						change={(k, v) => dispatch({ type:'CHANGE', k, v })}
						layer_actions= {(is_creating) ? (
							<ActionButton
								disabled={disabled_step0}
								onClick={() => dispatch({ type:'CHANGE', k:"step", v:1 })}
							>Continue</ActionButton>
						) : (
							<ButtonCollection
								in_floating={true}
								_class={{ other:'gui_flex_space_between' }}
							>
								{(props?.allow_delete) && (
									<DeleteButton
										disabled={state.candidate.User.id ? false : true}
										onClick={() => deleteCandidate(state.candidate.User.id)}
										tooltip={<Tooltip position='top' with_icon={false}>Delete entry</Tooltip>}
									/>
								)}

								<ActionButton
									disabled={disabled_step0}
									onClick={() => dispatch({ type:'CHANGE', k:"step", v:1 })}
								>Continue</ActionButton>
							</ButtonCollection>
						)}
						intl={props.intl}
					/>
				) : (
					<MediaParticipation
						key={`step_${state.step}`}
						is_game={false}
						is_add_builder={true}
						is_edit_builder={props?.is_edit_builder ?? false}
						stage={{Stage:props.stage}}
						promotion={props.promotion}
						submitMedias={submitMedias}
						participation={state.candidate.User}
						initial_step={state.step}
						is_builder={false}
						layer_actions={
							<BackButton
								onClick={() => dispatch({ type:'CHANGE', k:'step', v:0 })}
							/>
						}
					/>
				)}
			</div>
		</FloatingLayer>
	)
}

export default injectIntl(CandidateManager);